<template>
  <div v-if="visible" class="debug" @click="visible = false">
    <span>{{ env }}</span>
    <span v-if="env !== 'dev'"> | 构建时间: {{ buildTime }}</span>
  </div>
</template>

<script>
/* global __BUILD_TIME__ */

function formatBuildTime(ms) {
  const d = new Date(ms);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export default {
  name: 'Debug',
  data() {
    // 仅在 __ENABLE_DEBUG__ 为 true 时才会被打包挂载；挂载即展示，点击关闭后需刷新
    return {
      env: process.env.NODE_ENV_PACK_ENV || 'dev',
      buildTime: formatBuildTime(__BUILD_TIME__),
      visible: true,
    };
  },
};
</script>

<style scoped>
.debug {
  padding: 2px 4px;
  font-size: 12px;
  color: var(--kd-color-text-secondary, #666);
  cursor: pointer;
  background-color: var(--kd-color-fill-heavy, rgba(0, 0, 0, 0.06));
  border-bottom-left-radius: 4px;
}
</style>
